import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { base64Decode, Store } from '@softline/core';
import { ModalStore, SOFTLINE_FEATURE_MODAL } from '@softline/ui-core';
import {
  BestellungUebernehmenDialogComponent,
  SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG, SOFTLINE_FEATURE_LLR_KOMMISSIONIERUNG_BESTELLUNG
} from '@softapps/llr/kommisionierung';
import { LlrKommissionierungStore } from '../store/kommissionierung.store';
import { showRequestErrors } from '@softline/application';
import { LlrBestellungStore } from '../store/bestellung.store';

export interface Deactivateable {
  canDeactivate(params: any): Promise<boolean>
}

@Injectable()
export class LeaveBestellungenGuard {

  constructor(private store: Store, private router: Router) {}

  async canDeactivate(
    component: Deactivateable,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    if(nextState?.url.includes('/llr-bskomm/artikelauswahl')) {
      return component.canDeactivate(nextState?.root.queryParamMap.get('params'));
    }
    return true;
  }
}
